import { FormikValues } from 'formik';

import { FormProps } from '../../../';
import { FieldErrors } from '../../../';
import isPromise from '../../utils/isPromise';
import validateField from './fieldValidation';

const defaultValidate =
  <TValues extends FormikValues = FormikValues>(
    fields: FormProps<TValues>['fields'],
    customValidate: FormProps<TValues>['validate'],
  ) =>
  async (values: any) => {
    const fieldErrors: FieldErrors = {};

    Object.keys(fields || {}).forEach((fieldKey: string) => {
      const field = fields[fieldKey]!;
      const errorMessage = validateField(field, values[field.name], values);
      if (errorMessage) {
        fieldErrors[fieldKey] = errorMessage;
      }
    });

    let customErrors;
    if (isPromise(customValidate?.(values))) {
      customErrors = await customValidate?.(values);
    } else {
      customErrors = customValidate?.(values);
    }

    return { ...customErrors, ...fieldErrors };
  };

export default defaultValidate;
